<template>
  <div class="ai-recognition">
    <!-- 时间段筛选器 -->
    <el-card style="margin-bottom: 20px;">
      <div class="filter-section">
        <el-form :inline="true" :model="timeFilter" class="filter-form">
          <el-form-item label="统计时间段">
            <el-date-picker
              v-model="timeFilter.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="onTimeRangeChange"
              style="width: 350px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button-group>
              <el-button size="small" @click="setTimeRange('today')">今天</el-button>
              <el-button size="small" @click="setTimeRange('yesterday')">昨天</el-button>
              <el-button size="small" @click="setTimeRange('week')">本周</el-button>
              <el-button size="small" @click="setTimeRange('month')">本月</el-button>
              <el-button size="small" @click="setTimeRange('all')">全部</el-button>
            </el-button-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="loadAccuracyStats">查询</el-button>
            <el-button size="small" @click="resetTimeFilter">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 准确率统计卡片 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value">{{ accuracyStats.total }}</div>
            <div class="stat-label">总识别数</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value">{{ accuracyStats.judged }}</div>
            <div class="stat-label">已判断数</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value">{{ accuracyStats.accurate }}</div>
            <div class="stat-label">准确数</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value">{{ accuracyRate }}%</div>
            <div class="stat-label">准确率</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value">{{ accuracyStats.replied }}</div>
            <div class="stat-label">已回复数</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value">{{ replyRate }}%</div>
            <div class="stat-label">回复率</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 邮件类型统计 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value type-value" style="color: #409EFF;">{{ accuracyStats.type1 }}</div>
            <div class="stat-label">查询订单物流</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value type-value" style="color: #E6A23C;">{{ accuracyStats.type2 }}</div>
            <div class="stat-label">产品质量问题</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value type-value" style="color: #F56C6C;">{{ accuracyStats.type3 }}</div>
            <div class="stat-label">退款请求</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value type-value" style="color: #909399;">{{ accuracyStats.type4 }}</div>
            <div class="stat-label">广告邮件</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value type-value" style="color: #67C23A;">{{ accuracyStats.type5 }}</div>
            <div class="stat-label">订单修改</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card>
          <div class="stat-item">
            <div class="stat-value type-value" style="color: #606266;">{{ accuracyStats.type6 }}</div>
            <div class="stat-label">其他</div>
            <div class="stat-time">{{ timeFilterText }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 筛选器 -->
    <el-card style="margin-bottom: 20px;">
      <el-form :inline="true" :model="filterForm">
        <el-form-item label="邮件类型">
          <el-select v-model="filterForm.emailType" placeholder="请选择邮件类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="查询订单物流" :value="1"></el-option>
            <el-option label="产品质量问题" :value="2"></el-option>
            <el-option label="退款请求" :value="3"></el-option>
            <el-option label="广告邮件" :value="4"></el-option>
            <el-option label="订单修改" :value="5"></el-option>
            <el-option label="其他" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="准确率判断">
          <el-select v-model="filterForm.isAccurate" placeholder="请选择判断状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="未判断" :value="null"></el-option>
            <el-option label="准确" :value="true"></el-option>
            <el-option label="不准确" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工单ID">
          <el-input
            v-model="filterForm.ticketIdsInput"
            type="textarea"
            :rows="2"
            placeholder="多个ID用英文逗号或换行分隔，最多200个"
            style="min-width: 280px; vertical-align: middle;"
          />
        </el-form-item>
        <el-form-item label="列表时间段">
          <el-date-picker
            v-model="listTimeFilter.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            @change="onListTimeRangeChange"
            style="width: 350px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
          <el-dropdown trigger="click" @command="exportRecognitions">
            <el-button type="success" plain>
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="current">当前页</el-dropdown-item>
              <el-dropdown-item command="all">全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 识别结果列表 -->
    <el-card class="recognition-list-card">
      <div v-loading="loading">
        <div v-for="item in recognitions" :key="item.id" class="recognition-item" :data-item-id="item.id">
          <!-- 工单基本信息 -->
          <div class="item-header">
            <div class="item-info">
              <span class="ticket-id">工单ID: {{ item.ticket_id }}</span>
              <span class="subject">{{ item.subject }}</span>
            </div>
            <div class="item-meta">
              <span class="created-time">{{ formatDate(item.created_at) }}</span>
            </div>
          </div>

          <!-- 邮件内容 - 完整显示 -->
          <div class="content-section">
            <div class="content-label">
              邮件内容:
              <el-button 
                v-if="item.original_description" 
                type="text" 
                size="mini" 
                @click="toggleOriginalContent(item.id)"
                class="toggle-original-btn">
                {{ showOriginalContent[item.id] ? '显示清理后' : '显示原始内容' }}
              </el-button>
            </div>
            <div class="description-content" v-if="!showOriginalContent[item.id]" v-html="item.description"></div>
            <div class="description-content original-content" v-if="showOriginalContent[item.id]" v-html="item.original_description"></div>
          </div>

          <!-- 回复内容 - 放在下面方便比对 -->
          <div class="content-section" v-if="item.reply_content">
            <div class="content-label">回复内容:</div>
            <div class="reply-content" v-html="item.reply_content"></div>
          </div>

          <!-- 提取信息 -->
          <div class="extracted-info">
            <div class="info-item" v-if="item.customer_email">
              <span class="info-label">提取邮箱:</span>
              <span class="info-value">{{ item.customer_email }}</span>
            </div>
            <div class="info-item" v-if="item.order_no">
              <span class="info-label">订单号:</span>
              <span class="info-value">{{ item.order_no }}</span>
            </div>
            <div class="info-item" v-if="item.tracking_no">
              <span class="info-label">物流单号:</span>
              <span class="info-value">{{ item.tracking_no }}</span>
            </div>
            <div class="info-item" v-if="item.accuracy_judged_at">
              <span class="info-label">判断时间:</span>
              <span class="info-value">{{ formatDate(item.accuracy_judged_at) }}</span>
            </div>
          </div>

          <!-- 准确率判断 -->
          <div class="accuracy-section">
            <div class="accuracy-left">
              <el-tag :type="getTypeTag(item.email_type)" size="small">
                {{ getTypeName(item.email_type) }}
              </el-tag>
            </div>
            <div class="accuracy-right">
              <div v-if="item.is_accurate === null" class="accuracy-buttons">
                <el-button size="small" type="success" @click="markAccurate(item, true)">✓ 准确</el-button>
                <el-button size="small" type="danger" @click="markAccurate(item, false)">✗ 不准确</el-button>
              </div>
              <div v-else class="accuracy-status">
                <el-tag :type="item.is_accurate ? 'success' : 'danger'" size="small">
                  {{ item.is_accurate ? '✓ 准确' : '✗ 不准确' }}
                </el-tag>
                <el-button size="small" type="text" @click="resetAccuracy(item)">重新判断</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
// API调用已通过Vue实例挂载，使用this.api和this.http

export default {
  name: 'AIRecognition',
  data() {
    return {
      recognitions: [],
      loading: false,
      accuracyStats: {
        total: 0,
        judged: 0,
        accurate: 0,
        replied: 0,
        type1: 0,
        type2: 0,
        type3: 0,
        type4: 0,
        type5: 0,
        type6: 0
      },
      timeFilter: {
        dateRange: null,
        startTime: null,
        endTime: null
      },
      listTimeFilter: {
        dateRange: null,
        startTime: null,
        endTime: null
      },
      filterForm: {
        emailType: '',
        isAccurate: null, // 默认显示未判断的数据
        ticketIdsInput: ''
      },
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      showOriginalContent: {} // 控制每个项目是否显示原始内容
    }
  },
  computed: {
    accuracyRate() {
      if (this.accuracyStats.judged === 0) return 0
      return Math.round((this.accuracyStats.accurate / this.accuracyStats.judged) * 100)
    },
    replyRate() {
      if (this.accuracyStats.total === 0) return 0
      return Math.round((this.accuracyStats.replied / this.accuracyStats.total) * 100)
    },
    timeFilterText() {
      if (!this.timeFilter.startTime || !this.timeFilter.endTime) {
        return '全部时间'
      }
      const start = this.timeFilter.startTime.split(' ')[0]
      const end = this.timeFilter.endTime.split(' ')[0]
      if (start === end) {
        return start
      }
      return `${start} 至 ${end}`
    }
  },
  methods: {
    // 解析工单ID为查询参数（逗号分隔），与后端 ticket_ids 约定一致
    buildTicketIdsQueryParam() {
      const raw = (this.filterForm.ticketIdsInput || '').trim()
      if (!raw) return undefined
      const normalized = raw.replace(/\r\n/g, '\n').split(/[,\n]+/)
      const seen = new Set()
      const parts = []
      for (const seg of normalized) {
        const t = seg.trim()
        if (!t || !/^\d+$/.test(t)) continue
        const n = parseInt(t, 10)
        if (seen.has(n)) continue
        seen.add(n)
        parts.push(t)
        if (parts.length >= 200) break
      }
      return parts.length ? parts.join(',') : undefined
    },

    // 与列表接口一致的查询参数（供 loadData / 导出复用）
    buildListQueryParams() {
      const ticketIds = this.buildTicketIdsQueryParam()
      return {
        page: this.pagination.page,
        page_size: this.pagination.pageSize,
        email_type: this.filterForm.emailType || undefined,
        is_accurate: this.filterForm.isAccurate !== '' ? (this.filterForm.isAccurate === null ? 'null' : this.filterForm.isAccurate) : undefined,
        ticket_ids: ticketIds,
        start_time: this.listTimeFilter.startTime || undefined,
        end_time: this.listTimeFilter.endTime || undefined
      }
    },

    async exportRecognitions(exportScope) {
      if (exportScope === 'all') {
        try {
          await this.$confirm(
            '将按当前筛选条件导出，最多 1 万条（按创建时间从新到旧）。是否继续？',
            '导出全部',
            { type: 'info', confirmButtonText: '确定', cancelButtonText: '取消' }
          )
        } catch (e) {
          return
        }
      }
      const params = {
        ...this.buildListQueryParams(),
        export_scope: exportScope
      }
      try {
        const res = await this.http.fetchGetDown(this.api.ai_recognitions_export, params)
        const ct = (res.headers['content-type'] || '').toLowerCase()
        if (res.status !== 200 || ct.includes('application/json')) {
          const text = await res.data.text()
          try {
            const j = JSON.parse(text)
            this.$message.error(j.msg || j.message || '导出失败')
          } catch (_) {
            this.$message.error('导出失败')
          }
          return
        }
        const blob = new Blob([res.data], {
          type: ct || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        let name = exportScope === 'all' ? 'ai_recognition_all.xlsx' : 'ai_recognition_page.xlsx'
        const dispo = res.headers['content-disposition']
        if (dispo && dispo.includes('filename=')) {
          const m = /filename="?([^";]+)"?/.exec(dispo)
          if (m) name = m[1]
        }
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },

    // 加载数据
    loadData() {
      this.loading = true
      const params = this.buildListQueryParams()
      
      this.http.fetchGet(this.api.ai_recognitions, params).then(res => {
        if (res.data.code === 200) {
          this.recognitions = res.data.data.list
          this.pagination.total = res.data.data.total
        }
        this.loading = false
      }).catch(() => {
        this.$message.error('加载数据失败')
        this.loading = false
      })
    },
    
    // 加载准确率统计
    loadAccuracyStats() {
      const params = {
        start_time: this.timeFilter.startTime,
        end_time: this.timeFilter.endTime
      }
      
      this.http.fetchGet(this.api.ai_recognitions_stats, params).then(res => {
        if (res.data.code === 200) {
          this.accuracyStats = res.data.data
        }
      }).catch(() => {
        this.$message.error('加载统计数据失败')
      })
    },

    // 时间段变化处理（仅统计）
    onTimeRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.timeFilter.startTime = dateRange[0]
        this.timeFilter.endTime = dateRange[1]
      } else {
        this.timeFilter.startTime = null
        this.timeFilter.endTime = null
      }
    },
    
    // 设置预设时间段
    setTimeRange(type) {
      const now = new Date()
      let startTime, endTime
      
      switch (type) {
        case 'today': {
          startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
          endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
          break
        }
        case 'yesterday': {
          const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000)
          startTime = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0)
          endTime = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59)
          break
        }
        case 'week': {
          const weekStart = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
          startTime = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate(), 0, 0, 0)
          endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
          break
        }
        case 'month': {
          const monthStart = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0)
          endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
          startTime = monthStart
          break
        }
        case 'all':
          startTime = null
          endTime = null
          break
      }
      
      if (startTime && endTime) {
        this.timeFilter.dateRange = [
          this.formatDateTime(startTime),
          this.formatDateTime(endTime)
        ]
        this.timeFilter.startTime = this.formatDateTime(startTime)
        this.timeFilter.endTime = this.formatDateTime(endTime)
      } else {
        this.timeFilter.dateRange = null
        this.timeFilter.startTime = null
        this.timeFilter.endTime = null
      }
      
      this.loadAccuracyStats()
    },
    
    // 重置时间筛选（仅统计）
    resetTimeFilter() {
      this.timeFilter.dateRange = null
      this.timeFilter.startTime = null
      this.timeFilter.endTime = null
      this.loadAccuracyStats()
    },

    // 列表时间段变化（仅影响识别结果列表）
    onListTimeRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.listTimeFilter.startTime = dateRange[0]
        this.listTimeFilter.endTime = dateRange[1]
      } else {
        this.listTimeFilter.startTime = null
        this.listTimeFilter.endTime = null
      }
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    // 切换原始内容显示
    toggleOriginalContent(itemId) {
      this.$set(this.showOriginalContent, itemId, !this.showOriginalContent[itemId])
    },
    
    // 标记准确率
    markAccurate(row, isAccurate) {
      this.updateAccuracy(row.id, isAccurate)
    },
    
    // 重置准确率判断
    resetAccuracy(row) {
      this.updateAccuracy(row.id, null)
    },
    
    // 更新准确率
    updateAccuracy(id, isAccurate) {
      const data = {
        is_accurate: isAccurate,
        judged_by: this.$store.state.user_info.name || this.$store.state.user_info.username || '未知用户'
      }
      
      this.http.fetchPut(`${this.api.ai_recognitions_update_accuracy}/${id}/accuracy`, data).then(res => {
        if (res.data.code === 200) {
          this.$message.success('更新成功')
          
          // 添加消失动画
          this.animateItemDisappear(id)
          
          // 延迟刷新数据，让动画完成
          setTimeout(() => {
            this.loadData()
            this.loadAccuracyStats()
          }, 500)
        } else {
          this.$message.error(res.data.message || '更新失败')
        }
      }).catch(() => {
        this.$message.error('更新失败')
      })
    },
    
    // 动画消失效果
    animateItemDisappear(id) {
      // 找到对应的列表项元素
      const itemElement = document.querySelector(`[data-item-id="${id}"]`)
      if (itemElement) {
        // 先添加一个短暂的闪烁效果
        itemElement.style.backgroundColor = '#e8f5e8'
        itemElement.style.border = '2px solid #52c41a'
        
        // 延迟添加消失动画类
        setTimeout(() => {
          itemElement.classList.add('item-disappearing')
        }, 100)
      }
    },
    
    // 获取类型标签样式
    getTypeTag(type) {
      const tagMap = {
        1: 'primary',
        2: 'warning', 
        3: 'danger',
        4: 'info',
        5: 'success',
        6: 'default'
      }
      return tagMap[type] || 'default'
    },
    
    // 获取类型名称
    getTypeName(type) {
      const nameMap = {
        1: '查询订单物流',
        2: '产品质量问题',
        3: '退款请求',
        4: '广告邮件',
        5: '订单修改',
        6: '其他'
      }
      return nameMap[type] || '未知'
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN')
    },
    
    // 重置筛选
    resetFilter() {
      this.filterForm = {
        emailType: '',
        isAccurate: null, // 重置时也默认显示未判断的数据
        ticketIdsInput: ''
      }
      this.listTimeFilter = {
        dateRange: null,
        startTime: null,
        endTime: null
      }
      this.pagination.page = 1
      this.loadData()
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.loadData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    }
  },
  
  mounted() {
    this.loadData()
    this.loadAccuracyStats()
  }
}
</script>

<style scoped>
.filter-section {
  padding: 10px 0;
}
.filter-form {
  margin: 0;
}
.stat-item {
  text-align: center;
}
.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}
.stat-label {
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}
.stat-time {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
}
.type-value {
  font-size: 22px;
  font-weight: bold;
}
/* 识别结果项样式 */
.recognition-item {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 20px;
  padding: 16px;
  background: #fff;
  transition: box-shadow 0.3s;
}

.recognition-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 工单头部信息 */
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.item-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.ticket-id {
  font-weight: bold;
  color: #409EFF;
  font-size: 14px;
}

.subject {
  font-weight: 500;
  color: #303133;
  font-size: 16px;
  flex: 1;
}

.item-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.created-time {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

.item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.accuracy-buttons {
  display: flex;
  gap: 8px;
}

.accuracy-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 内容区域 */
.content-section {
  margin-bottom: 16px;
}

.content-label {
  font-weight: 600;
  color: #606266;
  margin-bottom: 8px;
  font-size: 14px;
}

.description-content {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 12px;
  line-height: 1.6;
  color: #495057;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.reply-content {
  background: #f0f9f0;
  border: 1px solid #b3e5b3;
  border-radius: 4px;
  padding: 12px;
  line-height: 1.4;
  color: #1f2937;
  white-space: normal;
  word-wrap: break-word;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* HTML邮件内容样式 */
.reply-content p {
  margin: 4px 0;
  line-height: 1.4;
}

.reply-content p:first-child {
  margin-top: 0;
}

.reply-content p:last-child {
  margin-bottom: 0;
}

.reply-content br {
  line-height: 1.2;
}

.reply-content strong, .reply-content b {
  font-weight: bold;
}

.reply-content em, .reply-content i {
  font-style: italic;
}

.reply-content a {
  color: #409EFF;
  text-decoration: underline;
}

.reply-content ul, .reply-content ol {
  margin: 4px 0;
  padding-left: 20px;
}

.reply-content li {
  margin: 2px 0;
  line-height: 1.3;
}

/* 减少多余的空白 */
.reply-content div {
  margin: 2px 0;
}

.reply-content div:empty {
  display: none;
}

/* 提取信息 */
.extracted-info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.info-label {
  font-weight: 500;
  color: #909399;
  font-size: 12px;
}

.info-value {
  color: #303133;
  font-size: 12px;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
}

/* 准确率判断区域 */
.accuracy-section {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accuracy-left {
  display: flex;
  align-items: center;
}

.accuracy-right {
  display: flex;
  align-items: center;
}

.accuracy-buttons {
  display: flex;
  gap: 8px;
}

.accuracy-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 消失动画 */
.recognition-item {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

.item-disappearing {
  opacity: 0;
  transform: translateX(-100%) scale(0.8);
  max-height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  box-shadow: none;
  background-color: #f0f9ff !important;
}

/* 增强动画效果 */
.recognition-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 滚动条美化 */
.description-content::-webkit-scrollbar,
.reply-content::-webkit-scrollbar {
  width: 6px;
}

.description-content::-webkit-scrollbar-track,
.reply-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.description-content::-webkit-scrollbar-thumb,
.reply-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.description-content::-webkit-scrollbar-thumb:hover,
.reply-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 列表卡片背景色 */
.ai-recognition .recognition-list-card {
  background-color: #edf1f7;
}

/* 切换按钮样式 */
.toggle-original-btn {
  margin-left: 10px;
  font-size: 12px;
  color: #409EFF;
}

.toggle-original-btn:hover {
  color: #66b1ff;
}

/* 原始内容样式 */
.original-content {
  background-color: #fff9e6;
  border-left: 3px solid #e6a23c;
  padding-left: 10px;
  position: relative;
}

.original-content::before {
  content: "原始内容";
  position: absolute;
  top: -20px;
  left: 0;
  font-size: 12px;
  color: #e6a23c;
  font-weight: bold;
}

/* 清理后内容样式 */
.description-content:not(.original-content) {
  background-color: #f0f9ff;
  border-left: 3px solid #409EFF;
  padding-left: 10px;
  position: relative;
}

.description-content:not(.original-content)::before {
  content: "清理后内容";
  position: absolute;
  top: -20px;
  left: 0;
  font-size: 12px;
  color: #409EFF;
  font-weight: bold;
}

/* 内容标签样式调整 */
.content-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px; /* 增加底部间距，为标签留出空间 */
}
</style>
